import {get, post } from './http'

/* 验证账号 */
export const checkUserName = p => post('/iplat/valid/user', p);

/* 验证账号 */
export const checkPassUserName = p => post(`${window.globalParameter.VUE_APP_PASS}/iplat-pass/web/validUser`, p);

/* 验证匹配账号密码 */
export const verifiCation = p => get('/iplat/verification/user/verificationUsername', p);
// 强制修改密码
export const updatePwdNew = p => post('/iplat/bp/member/updatePwdNew', p);

// 记录弱密码弹窗次数
export const addSkipUpdatePwdCount = p => post('/iplat/verification/user/addSkipUpdatePwdCount', p);

/* 验证码 */
export const checkCaptcha = p => post(`${window.globalParameter.VUE_APP_CYCORE}/fif_captcha/checkCaptcha`, p);

/* 获取手机号验证码 */
//export const getValidateCode = p => post('https://www.fifedu.com/iplat/bp/mobile/sendValidateCode', p);

/* 验证验证码 */
export const checkVerification = p => post('/iplat/bp/mobile/checkVerificationCode', p);

/* 提交新密码 */
export const resetPassWord = p => post('/iplat/bp/mobile/resetPass', p);

/* 4.1 获取验证码 */
export const getValidateCode = p => get(`${window.globalParameter.VUE_APP_PASS}/iplat-pass/mobile/getValidCode`, p);
/* 4.1 验证验证码 */
export const checkValidateCode = p => post(`${window.globalParameter.VUE_APP_PASS}/iplat-pass/mobile/checkValidCode`, p);

// 注册账号
export const registerAnAccount = p => get('/iplat/bp/mobile/phoneRegister', p);

// 获得注册验证码
export const getRegisterCode = p => get('/iplat/bp/mobile/getRegisterCode', p);

/* 找回-获取验证码 */
export const getNewValidateCode = p => post('/iplat/bp/mobile/sendValidateCodeV41', p);
/* 找回-检查验证码 */
export const checkNewValidateCode = p => post('/iplat/bp/mobile/checkVerificationCodeV41', p);
/* 找回-重置密码 */
export const resetNewPassWord = p => post('/iplat/bp/mobile/resetPassV41', p);


/* 获取绑定手机验证码 */
export const getBindPhoneValidateCode = p => post('/iplat/bp/uc/accountManagement/getValidCode', p);
/* 验证绑定手机验证码 */
export const checkBindPhoneValidateCode = p => post('/iplat/bp/uc/accountManagement/checkValidCodeBindPhone', p);

/* 获取绑定手机验证码 */
export const getBindPassPhoneValidateCode = p => post(`${window.globalParameter.VUE_APP_PASS}/iplat-pass/mobile/getValidCode`, p);
/* 验证绑定手机验证码 */
export const checkBindPassPhoneValidateCode = p => post('https://pass.fifedu.com/iplat-pass/mobile/checkValidCode', p);


// WEBPACK FOOTER //
// ./src/request/api-ysx.js